// import * as AWS from 'aws-sdk';
import * as AWSCognito from 'amazon-cognito-identity-js';
import cognitoConfig from './config';

// var creds = new AWS.CognitoIdentityCredentials({
//     IdentityPoolId: cognitoConfig.UserPoolId
// });
export default new AWSCognito.CognitoUserPool(cognitoConfig);


// WEBPACK FOOTER //
// ./src/services/AWSCognito/index.ts